
const IGImg = (props) => {
  const { useImageProxy = true, ...restProps } = props;
  const src = props.src ?? '/1x1-transparent.png';

  return (
    src == null
      ?
        <span className={`inline-block ${props.className ?? ''}`}></span>
      :
        <img
          {...restProps}
          src={src.startsWith('/') ? src : (useImageProxy ? `${process.env.REACT_APP_IMAGE_PROXY_URL}?url=${src}` : src)} 
          crossOrigin={useImageProxy ? 'anonymous' : undefined}
        />
  )
}

export default IGImg